import { useEffect, useRef, useState } from "react";
import polyline from "@mapbox/polyline";
import Map from "./Map";

export default function Activities({ selectedAthlete, showEvent, showTraining }) {
  const [routes, setRoutes] = useState([]);
  const [eventRoutes, setEventRoutes] = useState([]);
  const [revealCount, setRevealCount] = useState(0);
  const [activitiesRevealCount, setActivitiesRevealCount] = useState(null);

  const revealTimer = useRef(null);
  const activitiesTimer = useRef(null);
  const activitiesStarted = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const scope = params.get("scope");

    if (code) {
      const expectedState = sessionStorage.getItem("oauthState");
      sessionStorage.removeItem("oauthState");
      if (!expectedState || state !== expectedState) {
        console.error("OAuth state mismatch — possible CSRF attack, aborting.");
        window.history.replaceState({}, "", "/");
        return;
      }
      fetch(`${process.env.REACT_APP_BACKEND_URL}/strava/callback`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code, scope })
      })
        .then(r => r.json())
        .then(() => { window.location.href = "/onboarding"; });
    }

    // ── Event routes laden + reveal-timer ─────────────────────────────────
    fetch(`${process.env.REACT_APP_BACKEND_URL}/event-routes`)
      .then(r => r.json())
      .then(data => {
        if (!Array.isArray(data)) return;
        setEventRoutes(data);
        setRevealCount(0);
        let count = 0;
        if (revealTimer.current) clearTimeout(revealTimer.current);
        const tick = () => {
          count++;
          setRevealCount(count);
          if (count < data.length) revealTimer.current = setTimeout(tick, 800);
        };
        revealTimer.current = setTimeout(tick, 1500); // na zoom-animatie (~1250ms)
      })
      .catch(() => {});

    // ── Activiteiten laden ────────────────────────────────────────────────
    fetch(`${process.env.REACT_APP_BACKEND_URL}/activities`)
      .then(r => r.json())
      .then(data => {
        const mapped = data.map(a => ({
          id: a.activityId,
          name: a.name,
          displayName: a.athleteId?.displayName || a.athleteId?.name || "Onbekende atleet",
          firstName: a.athleteId?.firstName || "Onbekende atleet",
          lastName: a.athleteId?.lastName || "Onbekende atleet",
          description: a.description,
          date: a.date,
          distance: a.distance,
          duration: a.moving_time,
          athlete: a.athleteId?.name || "Onbekende atleet",
          profilePhoto: a.athleteId?.profilePhoto || null,
          isTraining: a.isTraining,
          routeGroupId: a.routeGroupId || null,
          points: polyline.decode(a.summary_polyline)
        }));
        setRoutes(mapped);
        setActivitiesRevealCount(0); // begin verborgen; timer increments later
      })
      .catch(() => {});

    return () => {
      if (revealTimer.current) clearTimeout(revealTimer.current);
      if (activitiesTimer.current) clearTimeout(activitiesTimer.current);
    };
  }, []);

  // ── Activiteiten-reveal starten zodra event routes klaar zijn ─────────
  useEffect(() => {
    if (activitiesStarted.current) return;
    if (!routes.length) return;

    const eventsDone = !eventRoutes.length || revealCount >= eventRoutes.length;
    if (!eventsDone) return;

    activitiesStarted.current = true;
    setActivitiesRevealCount(0);
    let count = 0;
    const delay = eventRoutes.length > 0 ? 400 : 600;
    const tick = () => {
      count++;
      setActivitiesRevealCount(count);
      if (count < routes.length) activitiesTimer.current = setTimeout(tick, 300);
    };
    activitiesTimer.current = setTimeout(tick, delay);
  }, [revealCount, eventRoutes.length, routes.length]);

  return (
    <div>
      <h1>Hartekind routes</h1>
      <Map
        routes={routes}
        eventRoutes={eventRoutes}
        revealCount={revealCount}
        activitiesRevealCount={activitiesRevealCount}
        selectedAthlete={selectedAthlete}
        showEvent={showEvent}
        showTraining={showTraining}
      />
    </div>
  );
}
